import { render } from "./receiptListReadonly.vue?vue&type=template&id=3238616e&scoped=true"
import script from "./receiptListReadonly.vue?vue&type=script&lang=js"
export * from "./receiptListReadonly.vue?vue&type=script&lang=js"

import "./receiptListReadonly.vue?vue&type=style&index=0&id=3238616e&scoped=true&lang=css"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3238616e"]])

export default __exports__